// Trigger ranges the API enforces; kept free of imports so node tests can load them.
export const MIN_TRIGGER_ALIGNER = 1;
export const MAX_TRIGGER_ALIGNER = 200;
export const MIN_TRIGGER_WEEKS = 1;
export const MAX_TRIGGER_WEEKS = 156;
export const MIN_TRIGGER_NOGOS = 1;
export const MAX_TRIGGER_NOGOS = 10;
